import classNames from 'classnames';
import React from 'react';

interface Props {
    inline?: boolean;
    spacing?: 'small' | 'default';
}

const List: React.SFC<Props> = ({ inline, spacing, ...props }) => {
    const children = React.Children.toArray(props.children);

    const classes = classNames('list', {
        'list--inline': inline,
        'list--unstyled': true,
        [`list--${spacing}-space`]: spacing !== 'default',
    });

    return (
        <ul className={classes}>
            {children.map((item, i) => (
                <li key={i} className="list__item">
                    {item}
                </li>
            ))}
        </ul>
    );
};

List.defaultProps = {
    spacing: 'default',
    inline: false,
};

export default List;
